import { LGraphNode, LiteGraph } from "litegraph.js";

export class MergeNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Merge";

    this.properties = {
      blend: "source-over",
      opacity: 1.0,
      offsetAY: 0,
      offsetBY: 0,
    };

    this._canvas = document.createElement("canvas");
    this._canvas.width = 1500;
    this._canvas.height = 1500;
    this._ctx = this._canvas.getContext("2d");

    this.addWidget("combo", "Blend", this.properties.blend, (val) => {
      this.properties.blend = val;
    }, {
      values: [
        "source-over", "multiply", "screen", "overlay",
        "darken", "lighten", "difference", "exclusion",
        "source-atop", "destination-over"
      ]
    });

    this.addWidget("slider", "Opacity B", this.properties.opacity, (val) => {
      this.properties.opacity = Math.round(val * 100) / 100;
    }, { min: 0, max: 1, step: 0.05 });

    this.addWidget("slider", "Offset A Y", this.properties.offsetAY, (val) => {
      this.properties.offsetAY = Math.round(val);
    }, { min: -500, max: 500, step: 1 });

    this.addWidget("slider", "Offset B Y", this.properties.offsetBY, (val) => {
      this.properties.offsetBY = Math.round(val);
    }, { min: -500, max: 500, step: 1 });

    this.addInput("Canvas A", "canvas");
    this.addInput("Canvas B", "canvas");
    this.addOutput("Canvas", "canvas");

    this.size = [200, 145];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onExecute() {
    const a = this.getInputData(0);
    const b = this.getInputData(1);

    const w = Math.max(a?.width || 0, b?.width || 0) || 1500;
    const h = Math.max(a?.height || 0, b?.height || 0) || 1500;

    if (this._canvas.width !== w || this._canvas.height !== h) {
      this._canvas.width = w;
      this._canvas.height = h;
    } else {
      this._ctx.clearRect(0, 0, w, h);
    }

    if (!a && !b) {
      this.setOutputData(0, this._canvas);
      return;
    }

    if (a) {
      this._ctx.globalAlpha = 1;
      this._ctx.globalCompositeOperation = "source-over";
      this._ctx.drawImage(a, 0, this.properties.offsetAY || 0);
    }

    if (b) {
      this._ctx.globalAlpha = this.properties.opacity;
      this._ctx.globalCompositeOperation = this.properties.blend;
      this._ctx.drawImage(b, 0, this.properties.offsetBY || 0);
    }

    this._ctx.globalAlpha = 1;
    this._ctx.globalCompositeOperation = "source-over";

    this.setOutputData(0, this._canvas);
  }
}

LiteGraph.registerNodeType("composite/Merge", MergeNode);
